module.exports = __webpack_public_path__ + "static/media/Schiratti1927-tagged.d073101c.jpg";